export const UPDATE_ATIVIDADE_ALUNOS = 'UDPATE_ATIVIDADE_ALUNOS'
export const SET_ATIVIDADE_ALUNOS = 'SET_ATIVIDADE_ALUNOS'
export const SET_ATIVIDADE_ALUNO = 'SET_ATIVIDADE_ALUNO'
export const ADD_ATIVIDADE_ALUNOS = 'ADD_ATIVIDADE_ALUNOS'
export const REMOVE_ATIVIDADE_ALUNOS = 'REMOVE_ATIVIDADE_ALUNOS'